﻿import { fieldsProxy } from "@serenity-is/corelib";
import { DataAuditLogType } from "./DataAuditLog.DataAuditLogType";

export interface DataAuditLogRow {
    LogId?: number;
    LogType?: DataAuditLogType;
    LogDate?: string;
    UserId?: number;
    Tablename?: string;
    RecordId?: string;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    Username?: string;
    UserDisplayName?: string;
}

export abstract class DataAuditLogRow {
    static readonly idProperty = 'LogId';
    static readonly localTextPrefix = 'Pro.DataAuditLog.DataAuditLog';
    static readonly deletePermission = 'Administration:DataAuditLog';
    static readonly insertPermission = 'Administration:DataAuditLog';
    static readonly readPermission = 'Administration:DataAuditLog';
    static readonly updatePermission = 'Administration:DataAuditLog';

    static readonly Fields = fieldsProxy<DataAuditLogRow>();
}